/* eslint-disable prettier/prettier */
export const ERROR_MSG_REQUIRED = "{0} is required.";
export const ERROR_MSG_EMAIL_FORMAT =
  "Please check the format of your email address and try again.";
export const ERROR_MSG_INVALID_PHONE_NUMBER = `Please enter a valid phone number.`;
export const ERROR_MSG_SELECT_ADDRESS =
  "Please enter a valid property address.";
export const ERROR_MSG_WRONG_BANK_DETAILS = [
  {
    type: "sortCode",
    errorCode: "Error Bank02",
    errorMsg: "Sort Code Not Found",
    message:
      "<strong>Sorry!</strong>&nbsp;The sort code you have entered is invalid. Please check your details and try again.",
  },
  {
    type: "accountNumber",
    errorCode: "Error Bank04",
    errorMsg: "Invalid account number passed",
    message:
      "<strong>Sorry!</strong>&nbsp;The account number you have entered is invalid. Please check your details and try again.",
  },
  {
    type: "accountAndSortCode",
    errorCode: "Error Bank01",
    message:
      "<strong>Sorry!</strong>&nbsp;The sort code & account number you have entered are invalid. Please check your details and try again.",
  },
];
export const ERROR_MSG_FAILED_CARD_PAYMENT =
  "<strong>Sorry!</strong>&nbsp;We can't take your card payment right now. Please try again in a few minutes or select a different payment option.";
export const ERROR_MSG_UNKNOWN_ERROR = "An error has occured.";
export const ERROR_MSG_MIN_LENGTH = "{0} must be at least {1} characters.";
export const ERROR_MSG_MAX_LENGTH =
  "{0} field may not be greater than {1} characters.";
export const ERROR_MSG_MAX_CHARACTER =
  "{0} may not be greater than {1} characters.";
export const ERROR_MSG_MAX_CHARACTER_COST_CLAIM =
  "{0} (£) may not be greater than 10 characters.";
export const ERROR_LEAD_NOT_EXISTS = "Lead does not exist.";

export const SYSTEM_ERRORS = {
  errorProductNotFound: {
    errorId: "errorProductNotFound",
    errorTitle: "Product not found",
    errorMessage: "Unfortunately we're unable to find this product. Please try again.",
    redirectPath: "adviserHub"
  },
  errorRedirectAdviserHub: {
    errorId: "errorRedirectAdviserHub",
    errorTitle: "Quote not found",
    errorMessage: "Unfortunately we're unable to find this quote. Please double check the details or alternatively create a new quote.",
    redirectPath: "adviserHub"
  },
  errorRedirectHomepage: {
    errorId: "errorRedirectHomepage",
    errorTitle: "Quote not found",
    errorMessage: "Unfortunately we're unable to find this quote. Please double check the details or alternatively create a new quote.",
    redirectPath: "homePage"
  },
  errorSessionExpired: {
    errorId: "errorSessionExpired",
    errorTitle: "Session expired",
    errorMessage: "Unfortunately your session has expired.",
    redirectPath: "adviserHub"
  }
}

export const ERROR_ALREADY_HAS_AN_APPLICATION_REQUEST =
  "This quote request already has an application against it";
export const ERROR_ALREADY_HAS_AN_APPLICATION_SESSION =
  "This quote session already has an application against it";
export const ELIGIBILITY_NOT_MET_CONTACT_D2C =
  "Please contact us on the number below and select option 2 to speak to a member of our team who may be able to assist you.";
export const ELIGIBILITY_NOT_MET_UNFORTUNATELY_CURRENT =
  "Unfortunately, you don't meet our eligibility requirements so, we're unable to offer you insurance at this time.";

export const ERROR_PREVIOUS_INVALID_FIVE_YEAR_DATE =
  "Sorry! Date of claim must be a date within the last 5 years.";
export const ERROR_PREVIOUS_INVALID_CLAIM_AMOUNT =
  "Only numbers up to two decimal places are allowed in this field.";
export const ERROR_MSG_ALPHANUMERIC_CHARACTERS_AND_SOME_SPECIAL_CHARACTER = `Please enter only alphanumeric characters, spaces, or any of the following characters in this field - ' , . /`;
export const ERROR_MSG_POSTCODE = "Please enter a valid postcode.";
export const ERROR_NAME_INVALID =
  "First character must be a letter. Only letters, spaces, hyphens, and apostrophes are allowed in this field.";
export const ERROR_NUMERICAL_ONLY = "Please enter numerical values only.";
export const ERROR_INVALID_EMAIL_ADDRESS =
  "Please enter a valid email address.";
export const ERROR_INVALID = "{0} is not valid.";

export const ERROR_TEXT_ONLY =
  "Please enter only alpha characters, ampersands, spaces and hyphens in this field.";
export const ERROR_MIN_LENGTH_SORT_CODE = "{0} must be at least 6 characters.";
export const ERROR_MAX_LENGTH_SORT_CODE =
  "{0} may not be greater than 6 characters.";

export const SAVE_AND_EXIT_REMINDER =
  "We will send you a message containing your quote reference number and a link to return to your quote at a later date.";

export const GETTING_QUOTE_HOME_MESSAGE =
  "Our Home Insurance is Defaqto 5 Star rated and includes a comprehensive range of features and benefits, including new for old replacement and alternative accommodation if you're ever unable to stay in your home.";
export const GETTING_QUOTE_LANDLORD_MESSAGE =
  "Our Landlord’s Insurance is 5 Star Defaqto rated, which means it provides a high level of features and benefits compared to other, similar insurance products as well as a range of optional extras for those with rental properties.";
export const GETTING_QUOTE_TENANTS_CONTENTS_MESSAGE =
  "Our Tenant’s Contents Insurance is Defaqto 5 Star rated and includes a comprehensive range of features and benefits, including accidental damage cover for TVs and audio-visual equipment and tenant’s liability included as standard.";
export const GETTING_QUOTE_TENANTS_LIABILITY_MESSAGE =
  "Our Tenant's Liability Insurance provides protection for tenant's in the event of any accidental damage to their landlord's property, for which they could be liable under the terms of their tenancy agreement.";
export const GETTING_QUOTE_MPPI_MESSAGE =
  "Mortgage Protection, is designed to give you peace of mind that, if you suffer an accident or sickness which prevents you from working, you’ll still be able to pay your mortgage. The policy can provide cover for up to 12 or 24 months, allowing you to focus on getting back on your feet.";
export const ERROR_MSG_USER_REF =
  "Please enter only alphanumeric characters, spaces, and special characters excluding < and >.";
export const GETTING_QUOTE_RENT_PROTECTION_MESSAGE =
  "Rent Protection gives you peace of mind that you won't lose out if your tenant can't or won't pay the rent. It provides extra legal support as standard including a 24-hour legal helpline for queries relating to the letting of the property and legal expenses to cover the legal fees needed to evict the tenant and regain vacant possession of the property if an unfortunate situation arises.'";
